import HELPER from '@/app/utils/HELPER';
import { handleUpdateVisibility } from '@/modules/gem-meter';
import { debounce } from '@modules/common';

(function (jQuery) {
  jQuery.gfResDisplay = function (element, options) {
    const defaults = {
      onSelected: function (value, $element) {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let $_targetElement;
    const _values = [
      {
        screen: 'lg',
        value: '1',
      },
      {
        screen: 'md',
        value: '1',
      },
      {
        screen: 'sm',
        value: '1',
      },
      {
        screen: 'xs',
        value: '1',
      },
    ];

    let $_gfDisplay;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      $_targetElement = $gryffBody.find('#' + merId);
      _this.initValues();
      _this.setTemplate();
      _this.updateDisplayList();

      $element.on('value-change', function () {
        _this.initValues();

        let index = 0;
        $_gfDisplay.find('.gfSegmentContent input').each(function () {
          jQuery(this).data('gfswitcher').setValue(_values[index].value);
          index++;
        });
      });
      return false;
    };

    this.initValues = function () {
      // init values & status
      const style = _this.getTargetCSS();
      for (let i = 0; i < _values.length; i++) {
        const screenT = _values[i].screen;
        const v = HELPER.getValueFromCSS($_targetElement, style, 'display', screenT, '');
        if (v == 'none') {
          _values[i].value = '0';
        } else {
          _values[i].value = '1';
        }
      }
      return false;
    };

    this.setTemplate = function () {
      const _template = '<div class="gfSegment"> <div class="gfSegmentContent" data-name="visibility"></div></div>';
      $element.after(_template);

      let html = '';
      for (let i = 0; i < _values.length; i++) {
        let desc = '';
        switch (_values[i].screen) {
          case 'lg':
            desc = 'Show on Desktop';
            break;
          case 'md':
            desc = 'Show on Laptop';
            break;
          case 'sm':
            desc = 'Show on Tablet';
            break;
          case 'xs':
            desc = 'Show on Mobile';
            break;
        }
        html +=
          '<input name="gf_display-' +
          _values[i].screen +
          '" value="' +
          _values[i].value +
          '" data-screen="' +
          _values[i].screen +
          '" data-description="' +
          desc +
          '" />';
      }
      $_gfDisplay = $element.next();
      $_gfDisplay.find('.gfSegmentContent').html(html);

      $_gfDisplay.find('.gfSegmentContent input').gfSwitcher({
        onBeforeChanged: function (value, $elm) {
          const screenType = $elm.attr('data-screen');

          let count = 0;
          for (let i = 0; i < _values.length; i++) {
            if (_values[i].value == '0') {
              count++;
            }
          }
          if (count == 3 && value == '0') {
            alert("You can't hide this element in all screens, better to delete it.");
            return false;
          }
        },
        onSelected: function (value, $elm) {
          const screenType = $elm.attr('data-screen');
          for (let i = 0; i < _values.length; i++) {
            if (_values[i].screen == screenType) {
              _values[i].value = value;
              break;
            }
          }
          _this.onValueChanged(screenType, value);
          debounce(() => {
            handleUpdateVisibility($_targetElement.attr('id'), screenType, value);
          })();

          // Trigger change các visibility cho các phần tử con trong Product List
          if (HELPER.isInsideTheList($_targetElement)) {
            HELPER.flagListItemChange($_targetElement, 'design-options');
            const $itemContent = $_targetElement.closest('.item-content');
            HELPER.detectContentChange($itemContent);
          }
          // $element.trigger('input-change');
          // history
          $element.trigger('history-change');
        },
      });

      return false;
    };

    this.onValueChanged = function (screenType, value) {
      let style = _this.getTargetCSS();

      if (value == '0') {
        value = 'none';
      } else {
        value = '';
      }
      const deOptions = [
        {
          key: 'display',
          value: value,
        },
      ];
      style = HELPER.designOptions2Style($_targetElement, screenType, style, deOptions, '', true);

      if ($_targetElement.data('label') == 'Popup') {
        const id = $_targetElement.attr('id').slice(2);
        style = HELPER.designOptions2Style(
          $('<div id="gf-popupOverlay' + id + '" />'),
          screenType,
          style,
          deOptions,
          '',
          true,
        );
        style = HELPER.designOptions2Style(
          $('<div id="gf-popup' + id + '" />'),
          screenType,
          style,
          deOptions,
          '',
          true,
        );
      }

      _this.setTargetCSS(style);
      _this.updateDisplayList();

      return false;
    };

    this.setTargetCSS = function (style) {
      if ($_targetElement.data('gfrow') != undefined) {
        $_targetElement.data('gfrow').runStyle(style);
      } else if ($_targetElement.data('gfmodule') != undefined) {
        $_targetElement.data('gfmodule').runStyle(style);
      } else if ($_targetElement.data('gfelement') != undefined) {
        $_targetElement.data('gfelement').runStyle(style);
      }
      return false;
    };

    this.getTargetCSS = function () {
      if ($_targetElement.data('gfrow') != undefined) {
        var style = $_targetElement.data('gfrow').getRowCSS();
      } else if ($_targetElement.data('gfmodule') != undefined) {
        var style = $_targetElement.data('gfmodule').getModuleCSS();
      } else if ($_targetElement.data('gfelement') != undefined) {
        var style = $_targetElement.data('gfelement').getElementCSS();
      }
      return style;
    };

    this.updateDisplayList = function () {
      const $displaySettingsGroup = $element.closest('.gfSettingGroup');
      const $displayTitleBar = $displaySettingsGroup.find('.gfSGTitleBar');
      let displayAll = true;
      const display = [];

      for (let i = 0; i < _values.length; i++) {
        if (_values[i].value == '1') {
          switch (_values[i].screen) {
            case 'lg':
              display.push('Desktop');
              break;
            case 'md':
              display.push('Laptop');
              break;
            case 'sm':
              display.push('Tablet');
              break;
            case 'xs':
              display.push('Mobile');
              break;
          }
        } else {
          displayAll = false;
        }

        $displayTitleBar.children('.gfDisplayList').remove();
        if (displayAll) {
          $displayTitleBar.append('<div class="gfDisplayList">(All)</div>');
        } else if (displayAll.length == 0) {
          $displayTitleBar.append('<div class="gfDisplayList">(None)</div>');
        } else {
          $displayTitleBar.append('<div class="gfDisplayList">(' + display.join(', ') + ')</div>');
        }
      }
    };

    this.init();
  };
  jQuery.fn.gfResDisplay = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfresdisplay')) {
        const plugin = new jQuery.gfResDisplay(this, options);
        jQuery(this).data('gfresdisplay', plugin);
      }
    });
  };
})(jQuery);
